import INFO_01 from '../../../assets/images/feature/feature-credit-01.png';
import INFO_02 from '../../../assets/images/feature/feature-credit-02.png';
import INFO_03 from '../../../assets/images/feature/feature-credit-03.png';
import INFO_04 from '../../../assets/images/feature/feature-credit-04.png';
export default [
  {
    source: INFO_01,
    alt: '상환 이력',
    title: '상환 이력',
    subTitle: '채무금액을 상환했는지 확인해요',
  },
  {
    source: INFO_02,
    alt: '신용 거래 기간',
    title: '신용 거래 기간',
    subTitle: '최초/최근 개설로부터 기간을 확인해요',
  },
  {
    source: INFO_03,
    alt: '신용의 형태',
    title: '신용의 형태',
    subTitle: '신용카드를 이용한 정보내역을 확인해요',
  },
  {
    source: INFO_04,
    alt: '부채 수준',
    title: '부채 수준',
    subTitle: '대출 및 보증채무 등 정보를 확인해요',
  },
];
